/*
 *
 * Console constants
 *
 */

export const STORE_KEY = 'Console';
